import actionTypes from 'constants/actionTypes';

export const addFolderModalInitValue = {
  data: {
    name: '',
    style: '',
    currentFolder: undefined,
    modalActionType: actionTypes.ADD,
    isLoading: false,
  },
  actions: {
    handleCloseModal: () => {},
    handleChangeName: () => {},
    handleChangeStyle: () => {},
    handleSaveFolder: () => {},
  },
};
